/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import createAsyncMutation from '@/utils/generators'

// Initial state
const state = {
  status: null,
  error: null,
  vehicle: {},
  session: {
    data: [],
    statistics: {}
  }
}

// Getters
const getters = {
  demoLoading: state => state.status === 'loading',
  demoStatus: state => state.status,
  demoError: state => state.error,
  demoSession: state => state.session,
  demoSessionData: state => state.session.data,
  demoVehicle: state => state.vehicle
}
// Mutations
const mutations = {
  GET_DEMO_SESSION_PENDING(state) {
    state.status = 'loading'
  },
  GET_DEMO_SESSION_SUCCESS(state, demoSessionData) {
    state.error = null
    state.status = 'success'
    state.vehicle = demoSessionData.data.vehicle
    state.session.data = demoSessionData.data.session_data // nested array
    state.session.statistics = demoSessionData.data.last_session_stats
    state.session = Object.assign({}, state.session, demoSessionData.data.last_session)
  },
  GET_DEMO_SESSION_FAILURE(state, error) {
    state.error = error || 'We failed to load the demo session'
    state.status = 'error'
  }
}

// Actions
const actions = {
  getDemoSession: ({ dispatch, rootState }, params) => {
    const url = `${rootState.api.host}/${rootState.api.endpoints.demo}/`
    const options = { params }
    const mutationTypes = createAsyncMutation('GET_DEMO_SESSION')
    dispatch('fetch', { url, mutationTypes, options })
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/demo.js